const awsConfigDev = {
	aws_cognito_region: "eu-central-1",
	aws_user_pools_id: "eu-central-1_sdUGlXGu7",
	aws_user_pools_web_client_id: "7aftb1ecupfgvfnt1t4unvfl61",
};
const awsConfigProd = {
	aws_cognito_region: "eu-central-1",
	aws_user_pools_id: "eu-central-1_qdfJS2x7I",
	aws_user_pools_web_client_id: "436l37q6tji0jf7ii20f3hujhl",
};
const devConfig = { apiUrl: "http://localhost/api", awsConfig: awsConfigDev, appUrl: "http://localhost" };
const localConfig = { apiUrl: "http://localhost:5001/api", awsConfig: awsConfigDev, appUrl: "http://localhost:3000" };
const prodConfig = { apiUrl: "https://app.e-rentit.ro/api", awsConfig: awsConfigProd, appUrl: "https://app.e-rentit.ro" };
const getConfig = (env) => {
	switch (env) {
		case "dev":
			console.log("Dev config");
			return devConfig;
		case "local":
			console.log("Local config");
			return localConfig;
		case "prod":
			console.log("Prod config");
			return prodConfig;
		default:
			console.warn("No config found for environment: ", env);
			return devConfig;
	}
};
const ENV = process.env.REACT_APP_environment?.toLowerCase();
console.log(`Environment: ${ENV}`);

const config = getConfig(ENV);

export { config };
